import React, { Component } from 'react'
import '../../sass/_talk-data.scss';
import Cbutton from '../button';
import getConfig from 'next/config';
const { serverRuntimeConfig, publicRuntimeConfig } = getConfig();
import ScrollAnimation from 'react-wow';

export default class index extends Component {
    render() {
        return (
            // <ScrollAnimation animateIn='bounceInLeft' animateOut='bounceInRight'>
            <div className={this.props.spectial && "talk-bg pb-4"}>
                <section className={this.props.spectial ? "mt-5 pt-5 pb-5" : "mt-5 mb-2 pt-2 pb-5"}>
                    {this.props.image &&
                        <ScrollAnimation animation='wobble' initiallyVisible={true}>
                            <img src={`${publicRuntimeConfig.staticFolder}/images/extra-style.svg`} alt="extra-style" className="talk-sps-img" />
                        </ScrollAnimation>}
                    <ScrollAnimation animation='bounceInLeft'>
                        <div className={this.props.spectial ? "text-center main-heading pt-sm-5 talk-bg" : "text-center main-heading pt-sm-5"}>
                            {this.props.title}</div>
                        <div className={this.props.spectial ? "text-center talk-content pt-sm-2 talk-bg" : "text-center talk-content pt-sm-2"}>
                            {this.props.subtitle}
                        </div>
                        <div className="mt-4 pb-4"><Cbutton name="Get Started!" route="get-estimate" /></div>
                    </ScrollAnimation>
                </section>
            </div>
            // </ScrollAnimation>
        )
    }
}
